var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6837 0.449691L16.2948 7.39414C16.5066 7.80386 16.3469 8.30733 15.909 8.51709C15.7859 8.58111 15.6546 8.6115 15.525 8.6115C15.2239 8.6115 14.9337 8.44754 14.785 8.16219L11.2052 1.21775C10.993 0.80976 11.1521 0.306427 11.56 0.0948299C11.9698 -0.118712 12.4704 0.0406632 12.6837 0.449691ZM7.31547 0.451077C7.52728 0.0431951 8.03075 -0.116284 8.44047 0.0963548C8.84672 0.307952 9.00645 0.811494 8.73249 1.21913L5.15263 8.16358C5.00401 8.44903 4.71325 8.61288 4.4127 8.61288C4.31547 8.61288 4.18353 8.58163 4.05922 8.51705C3.6512 8.30559 3.49224 7.80212 3.70436 7.39413L7.31547 0.451077Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19.4444 6.66838L15.9167 6.66842L16.2948 7.39551C16.5069 7.80349 16.3479 8.30696 15.9399 8.51842C15.8168 8.58245 15.6855 8.61283 15.5559 8.61283C15.2548 8.61283 14.9646 8.44898 14.816 8.16353L14.0389 6.66804H5.96181L5.18403 8.16491C5.03472 8.44963 4.74306 8.61283 4.41319 8.61283C4.28354 8.61283 4.15222 8.58244 4.02917 8.51842C3.65278 8.30727 3.49306 7.8038 3.70486 7.39408L4.08299 6.66699L0.555556 6.66838C0.24875 6.66838 0 6.91713 0 7.19269V8.3038C0 8.6106 0.24875 8.8281 0.555556 8.8281H1.35799L2.94653 15.9774C3.17257 17.0573 4.07292 17.7795 5.11458 17.7795H14.8819C15.8924 17.7795 16.8253 17.0562 17.0514 16.0392L18.6399 8.88991H19.4444C19.7513 8.88991 20 8.64116 20 8.3656V7.22394C20 6.91838 19.75 6.66838 19.4444 6.66838Z",
    fill: "black",
    fillOpacity: 0.87
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.43dddbe63fd71103351fabd8d6dca42a.svg";
export { ForwardRef as ReactComponent };